// Minimal listener for Views Infinite Scroll new content event
// Logs and triggers Trig re-initialization. No extra functions.

((Drupal, once) => {
  Drupal.behaviors.viewsInfiniteScrollTrig = {
    attach: (context) => {
      // Run after each Drupal.attachBehaviors call that affects the view.
      // The VIS module calls Drupal.attachBehaviors(view.$view[0]) after AJAX completes.
      const containsWrapper =
        (context &&
          typeof context.matches === 'function' &&
          context.matches('.views-infinite-scroll-content-wrapper')) ||
        (typeof context.querySelector === 'function' &&
          context.querySelector('.views-infinite-scroll-content-wrapper'));

      if (containsWrapper) {
        if (
          typeof trig !== 'undefined' &&
          trig &&
          typeof trig.trigInit === 'function'
        ) {
          // Defer to ensure DOM append/paint are complete.
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              try {
                trig.trigInit();
              } catch (err) {
                /* no-op */
              }
            });
          });
        }
      }
    },
  };
})(Drupal, once);
